<template>

    <div>

        <header id="H" class="register">
            <img src="/static/img/app/logo_gorsh.svg?v=1.0" class="logo" />

            <div class="table">
                <div class="cell">
                    <h1>Wholesellers</h1>
                    <p>Creá tu cuenta de Gorsh para<br> usuarios mayoristas.</p>
                </div>
            </div>
        </header>

        <section class="register">
            <div class="container">
                <div class="panel">

                    <form enctype="multipart/form-data" method="post" action="" lang="es">

                        <div class="box-title">
                            <h1>Olvide mi contraseña</h1>
                            <p>
                                Don't worry! Completá tu email y te enviaremos un email con una nueva contraseña.
                            </p>
                        </div>

                        <div class="row">

                            <!-- -->
                            <div class="col-md-6">
                                <input class="required" name="user" type="text"
                                       placeholder="Email *"  />
                            </div>

                            <div class="col-lg-12">
                                <br>
                                <input type="submit"
                                       class="submit btn-submit"
                                       value="RECUPERAR CONTRASEÑA">
                            </div>

                        </div>

                        <ul class="login-links">
                            <li>
                                <router-link to="login">&bull; Ya estoy registrado. Loguearme.</router-link>
                            </li>
                            <li>
                                <router-link to="register">&bull; ¿No estas registrado? Solitica tu acceso.</router-link>
                            </li>
                        </ul>

                    </form>

                </div>
            </div>
        </section>

    </div>
    
</template>

<script>
    export default {
        name: "ForgotPage",
        mounted(){
            $('body').removeClass();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ForgotPage.vue